import { OperationVariables, QueryResult, useMutation, useQuery } from '@apollo/client';
import CREATE_STUDENT_ASSESSMENT_OUTCOME from 'graph/queries/student-assessment-outcome/create-student-assessment-outcome';
import FIND_STUDENT_ASSESSMENTS_OUTCOMES from 'graph/queries/student-assessment-outcome/find-student-assessment-outcomes';
import UPDATE_STUDENT_ASSESSMENT_OUTCOME from 'graph/queries/student-assessment-outcome/update-student-assessment-outcome';
import { StudentAssessmentOutcome } from 'types';

export type StudentAssessmentOutcomeStoreState = {
  studentAssessmentOutcomes?: StudentAssessmentOutcome[];
  loading: boolean;
};

export type StudentAssessmentOutcomeStoreDispatch = {
  studentAssessmentRefetch: any;
};
export type StudentAssessmentOutcomeStore = [
  StudentAssessmentOutcomeStoreState,
  StudentAssessmentOutcomeStoreDispatch
];

const variables: OperationVariables = {
  where: { assessmentId: '', studentId: '' },
};

const useStudentAssessmentOutcomesStore = (
  assessmentId: number,
  studentId: number,
  assessmentSectionId: number
): StudentAssessmentOutcomeStore => {
  variables.where.assessmentId = assessmentId;
  variables.where.studentId = studentId;
  variables.where.assessmentSectionId = assessmentSectionId;
  const {
    data,
    loading,
    //    error,
    refetch: studentAssessmentRefetch,
  }: QueryResult<{ studentAssessmentOutcomes: StudentAssessmentOutcome[] }> = useQuery(
    FIND_STUDENT_ASSESSMENTS_OUTCOMES,
    {
      variables: variables,
    }
  );

  return [
    {
      studentAssessmentOutcomes: data?.studentAssessmentOutcomes,
      loading,
    },
    {
      studentAssessmentRefetch,
    },
  ];
};

export const useCreateStudentAssessmentOutcomeStore = () => {
  const [create] = useMutation<{
    createStudentAssessmentOutcome: { studentAssessmentOutcome: StudentAssessmentOutcome };
  }>(CREATE_STUDENT_ASSESSMENT_OUTCOME, {
    variables: {
      data: {
        studentId: 0,
        assessmentId: 0,
        assessmentSectionId: 0,
        assessmentQuestionId: 0,
        answerTypeOptionId: 0,
      },
    },
  });
  return create;
};

export const useUpdateStudentAssessmentOutcomeStore = () => {
  const [update] = useMutation<{
    updateStudentAssessmentOutcome: { studentAssessmentOutcome: StudentAssessmentOutcome };
  }>(UPDATE_STUDENT_ASSESSMENT_OUTCOME, {
    variables: {
      where: {
        studentAssessmentOutcomeId: {
          studentId: 0,
          assessmentId: 0,
          assessmentSectionId: 0,
          assessmentQuestionId: 0,
        },
      },
      data: {
        answerTypeOptionId: 0,
      },
    },
  });
  return update;
};

export default useStudentAssessmentOutcomesStore;
